import { gql } from "@apollo/client";

export const UPDATE_PASSENGER = gql`
  mutation updatePassenger($data: UpdatePassengerInput!) {
    updatePassenger(data: $data) {
      id
      name
    }
  }
`;

export const CREATE_PASSENGER = gql`
  mutation createPassenger($data: CreatePassengerInput!) {
    createPassenger(data: $data) {
      id
      name
    }
  }
`;

export default UPDATE_PASSENGER;
